import { FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Modal, Typography } from '@mui/material';
import { Col } from 'shared/ui/Col';
import { Row } from 'shared/ui/Row';

interface AnalyticsPromoCardProps {
  title: string;
  subtitle: string;
  modalContent?: ReactNode;
  image?: ReactNode;
  minWidth?: number | string;
  modalMaxWidth?: number | string;
}

export const AnalyticsPromoCard: FC<AnalyticsPromoCardProps> = ({
  title,
  subtitle,
  modalContent,
  image,
  minWidth,
  modalMaxWidth = 1200,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#F2F2F2',
          borderRadius: 2,
          minWidth: minWidth,
          p: '20px',
          position: 'relative',
        }}
      >
        <Row sx={{ position: 'relative' }}>
          <Col spacing={8} sx={{ flex: 1, maxWidth: 380 }}>
            <Col spacing={3}>
              <Typography variant="headerXS">{title}</Typography>
              <Typography variant="paragraphS">{subtitle}</Typography>
            </Col>
            {modalContent && (
              <Button size="small" onClick={handleOpen}>
                {t('analytics.object.promo.linkButton')}
              </Button>
            )}
          </Col>

          <Box
            sx={{
              position: 'absolute',
              top: -20,
              right: 0,
              width: 120,
              height: '100%',
              background: `linear-gradient(271.16deg, #FFA800CF, #FD4E00F5)`,
              filter: 'blur(60px)',
              zIndex: 0,
            }}
          />

          {image && (
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                zIndex: 1,
                p: 2,
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              {image}
            </Box>
          )}
        </Row>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            p: 8,
            maxWidth: modalMaxWidth,
            width: '90%',
          }}
        >
          {modalContent}
          <Button onClick={handleClose} size="small" sx={{ mt: 8 }}>
            {t('ui.common.close')}
          </Button>
        </Box>
      </Modal>
    </>
  );
};
